import { jwtDecode } from "jwt-decode";
import { useRefreshToken } from "../hooks";
import { AUTHENTICATED_EMPLOYEE_JWT } from "../constants";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export const useTokenRefresh = () => {
  const { RefetchRefreshToken } = useRefreshToken();
  const navigate = useNavigate();

  const [logoutTimer, setLogoutTimer] = useState(null);
  const [intervalId, setIntervalId] = useState(null);
  const [userActivity, setUserActivity] = useState(false);

  useEffect(() => {
    const resetTimer = () => {
      if (logoutTimer) {
        clearTimeout(logoutTimer);
      }

      setUserActivity(true);

      const LogoutTimer = setTimeout(() => {
        setUserActivity(false);
      }, 3600000); // set the timeout to 1 hour

      setLogoutTimer(LogoutTimer);
    };

    const addMultipleEventListeners = (events, handler) => {
      events.forEach((event) => window.addEventListener(event, handler));
    };

    const removeMultipleEventListeners = (events, handler) => {
      events.forEach((event) => window.removeEventListener(event, handler));
    };

    const events = ["mousemove", "keydown", "scroll"];
    addMultipleEventListeners(events, resetTimer);

    const checkTokenAndUpdate = async () => {
      const token = localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT);

      if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        const expiryTime = decodedToken.exp;
        const timeLeft = expiryTime - currentTime;

        if (timeLeft < 15 * 60 && userActivity) {
          await RefetchRefreshToken();
          setUserActivity(false); // Reset user activity after refreshing token
        } else if (timeLeft < 0 || (timeLeft < 15 * 60 && !userActivity)) {
          // If the token is expired or there is no user activity, logout the user
          localStorage.removeItem(AUTHENTICATED_EMPLOYEE_JWT);
          navigate("/login");
          window.location.reload();
        }
      }
    };

    const IntervalId = setInterval(checkTokenAndUpdate, 1000); // Check every second
    setIntervalId(IntervalId);

    return () => {
      clearInterval(IntervalId);
      clearTimeout(logoutTimer);
      removeMultipleEventListeners(events, resetTimer);
    };
  }, [RefetchRefreshToken, navigate, userActivity, logoutTimer]);
};
